import { Shield } from 'lucide-react'
import { isStagingMode } from '@/lib/staging'

const permColors: Record<string, string> = {
  pages_show_list: 'border-emerald-500/40 bg-emerald-500/5 text-emerald-600',
  pages_read_engagement: 'border-blue-500/40 bg-blue-500/5 text-blue-600',
  pages_messaging: 'border-orange-500/40 bg-orange-500/5 text-orange-600',
  pages_manage_metadata: 'border-purple-500/40 bg-purple-500/5 text-purple-600',
  pages_manage_posts: 'border-pink-500/40 bg-pink-500/5 text-pink-600',
}

interface PermissionBadgeProps {
  permissions: {
    name: string
    endpoint: string
    description: string
  }[]
}

export function PermissionBadge({ permissions }: PermissionBadgeProps) {
  if (!isStagingMode()) return null

  return (
    <div className="mb-4 space-y-2">
      {permissions.map((p) => (
        <div
          key={p.name}
          className={`flex items-start gap-3 rounded-lg border p-3 ${permColors[p.name] || 'border-gray-500/40 bg-gray-500/5 text-gray-600'}`}
        >
          <Shield className="h-4 w-4 mt-0.5 shrink-0" />
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-xs font-bold font-mono">{p.name}</span>
              <span className="text-[10px] font-mono opacity-70">{p.endpoint}</span>
            </div>
            <p className="text-[11px] opacity-80 mt-0.5">{p.description}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
